import { useEffect } from 'react';

// Keeps track of prefetched URLs to avoid duplicate link tags
const prefetched = new Set();

/**
 * Intelligent System to download pages in the background.
 * Attaches a global event listener to prefetch internal links on hover.
 */
export default function Prefetcher() {
  useEffect(() => {
    const handleMouseOver = (e) => {
      const target = e.target.closest('a');
      if (!target || !target.href) return;

      try {
        const url = new URL(target.href);
        
        // Only prefetch internal links (same origin) and not anchors on the same page
        if (url.origin !== window.location.origin) return;
        if (url.pathname === window.location.pathname && url.hash) return;

        // Skip if already prefetched to avoid bloating the head
        if (prefetched.has(url.pathname)) return;

        prefetched.add(url.pathname);

        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url.href;
        // Optionally set as="document" or omit it
        document.head.appendChild(link);
      } catch (err) {
        // Ignore invalid URLs
      }
    };

    // Use event delegation on the document for performance
    document.addEventListener('mouseover', handleMouseOver, { passive: true });
    
    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);

  return null;
}
